import { getTableIntentLink } from "@components/drillDown/DrillDown.utils";
import { IGetValueArgs } from "@components/smart/FieldInfo";
import { IFormGroupDef } from "@components/smart/smartFormGroup/SmartFormGroup";
import { TCellValue } from "@components/table";
import { getDetailRouteByEntityType } from "@odata/EntityTypes";
import { EntitySetName, IPrSubmissionEntity, PrSubmissionEntity } from "@odata/GeneratedEntityTypes";
import { IFormatOptions } from "@odata/OData.utils";
import {
    getSubmissionStatusTableDef,
    getSubmissionSubTypeTableDef,
    getSubmissionTypeTableDef
} from "@pages/payroll/submission/Submission.def";
import { getSubmissionEntityType } from "@pages/payroll/submission/Submission.utils";

import { Sort } from "../../../enums";
import { TValue } from "../../../global.types";
import i18next from "../../../i18n";

export const SUBMISSION_FORM_TABLE_ID = "formSubmissionsTable";

export function getSubmissionTableDefinitionForFormTabs(filterProp: PrSubmissionEntity | string): IFormGroupDef {
    return {
        id: "submissions",
        title: i18next.t("Submission:SubmissionsTab"),
        table: {
            id: SUBMISSION_FORM_TABLE_ID,
            entitySet: EntitySetName.PrSubmissions,
            filter: (args: IGetValueArgs) => {
                return `${filterProp}/Id eq ${args.storage.data.entity.Id}`;
            },
            initialSortBy: [{ id: PrSubmissionEntity.NumberOurs, sort: Sort.Asc }],
            columns: [
                {
                    id: PrSubmissionEntity.NumberOurs,
                    formatter: (val: TValue, {
                        entity,
                        storage
                    }: IFormatOptions<IPrSubmissionEntity>): TCellValue => {
                        const { Id, SubmissionTypeCode, SubmissionSubtypeCode } = entity;
                        const entityType = getSubmissionEntityType(SubmissionTypeCode, SubmissionSubtypeCode);
                        return getTableIntentLink(val as string, {
                            route: getDetailRouteByEntityType(entityType, Id, false),
                            context: storage.context,
                            storage
                        });
                    },
                    additionalProperties: [
                        { id: PrSubmissionEntity.SubmissionTypeCode },
                        { id: PrSubmissionEntity.SubmissionSubtypeCode }
                    ]
                },
                // Do we really need to show employee here as it will be always same?
                // ...getEmployeeTableColumnDefs(PrSubmissionEntity.EmployeeHeader),
                {
                    id: PrSubmissionEntity.SubmissionType,
                    ...getSubmissionTypeTableDef()
                },
                {
                    id: PrSubmissionEntity.SubmissionSubtype,
                    ...getSubmissionSubTypeTableDef()
                },
                {
                    id: PrSubmissionEntity.SubmissionStatus,
                    ...getSubmissionStatusTableDef()
                },
                { id: PrSubmissionEntity.DateCreated },
            ]
        }
    };
}